<template>
  <div :class="['app-collapse', variantClass, outerClass]">
    <div
      class="app-collapse-title"
      :class="{ 'is-open': isOpen, 'cursor-pointer': !disabled }"
      @click="!disabled && toggle()"
    >
      <slot
        name="heading"
        data-sentry-unmask
      >
        {{ heading }}
      </slot>
      <span
        v-if="!disabled && !hideToggle"
        class="app-collapse-icon"
      >
        <template v-if="openLabel || closeLabel">{{ isOpen ? openLabel : closeLabel }}</template>
        <app-icon
          v-else
          :name="isOpen ? openedIcon : closedIcon"
        />
      </span>
    </div>
    <slide-down>
      <div
        v-show="isOpen"
        class="app-collapse-content"
      >
        <div :class="innerClass">
          <slot />
        </div>
      </div>
    </slide-down>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import SlideDown from './transitions/SlideDown.vue';

defineOptions({
  name: 'AppCollapse',
});

const props = defineProps({
  heading: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  openedIcon: {
    type: String,
    default: 'chevron-down',
  },
  closedIcon: {
    type: String,
    default: 'chevron-up',
  },
  openLabel: {
    type: String,
    default: null,
  },
  closeLabel: {
    type: String,
    default: null,
  },
  variant: {
    type: String,
    default: null,
    validator: (value) => ['muted'].includes(value),
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  outerClass: {
    type: String,
    default: '',
  },
  innerClass: {
    type: String,
    default: 'pt-4',
  },
});

const variantClass = computed(() => (props.variant === 'muted' ? 'app-collapse-muted' : null));

const isOpen = ref(props.isOpen);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

defineExpose({
  isOpen,
});
</script>

<style>
@reference '@/assets/main.css';

.app-collapse {
  @apply overflow-hidden;
}

.app-collapse-title {
  @apply text-sm font-semibold flex items-start gap-2 select-none;
}

.app-collapse-icon {
  @apply transition-transform duration-200 ml-auto;
}

.app-collapse-content {
  @apply overflow-hidden;
}

.app-collapse-muted {
  @apply bg-gray-100 rounded-lg px-3 py-3;
}
</style>
